import React from 'react'

export default function FaceFeature({ scaleX, fill, outline, verticalOffset }) {
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g>
        <path
          d="M40.2,12.8c-1.1,2.9-3.1,9.5-3.1,9.5,0,0,.2-4.1-.6-4.8-.8-.7-11.2-4.4-11.2-4.4,0,0-10.6,3.7-11.4,4.4-.9.8-.5,4.8-.5,4.8,0,0-2.1-6.6-3.1-9.5C9,10,2,3,2,3c1.6,19.9,7.4,32.8,11.8,36.2,3.5,2.8,8.3,3.2,11.4,3.2s7.9-.4,11.4-3.2c4.3-3.4,10.1-16.3,11.8-36.2,0,0-7,6.9-8.1,9.8ZM31.2,31.2l-6-4.5-5.6,4.5-2.4-11s2.8,1.4,8,1.4,8-1.4,8-1.4l-2,11Z"
          fill={fill}
          stroke={outline}
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          stroke={outline}
          strokeWidth="0.5"
          strokeMiterlimit="10"
          fill={fill}
          d="M19.4,41.7c0-.1-.3-2.7,0-10.7,0-.7,0,0,0-.7l.5.5c0,.8,0-.4,0,.3-.2,8,0,10.6,0,10.6h-.5Z"
        />
        <path
          stroke={outline}
          strokeWidth="0.5"
          strokeMiterlimit="10"
          fill={fill}
          d="M20.6,21.3h-.5c.8-4.8,1.8-7,1.9-7.1l.4.2s-1.1,2.2-1.8,6.9Z"
        />
        <path
          stroke={outline}
          strokeWidth="0.5"
          strokeMiterlimit="10"
          fill={fill}
          d="M16.2,40.3c-1.6-15.1,2.7-24.5,2.7-24.6l.5.2c0,0-4.3,9.4-2.7,24.3h-.5Z"
        />
        <path
          stroke={outline}
          strokeWidth="0.5"
          strokeMiterlimit="10"
          fill={fill}
          d="M22.8,42.3c-.5-4-.6-8.6-.5-13.6h.8c-.1,4.9,0,9.5.5,13.5h-.7Z"
        />
        <path
          stroke={outline}
          strokeWidth="0.5"
          strokeMiterlimit="10"
          fill={fill}
          d="M23.4,21.6h-.7c.3-4.6.8-7.6.8-7.6h.7c0,.1-.4,3.2-.8,7.6Z"
        />
        <path
          stroke={outline}
          strokeWidth="0.5"
          strokeMiterlimit="10"
          fill={fill}
          d="M11.2,35.1h-.5c.1-9.4,3-17,3.1-17.1l.5.2c0,0-2.9,7.6-3,16.9Z"
        />
        <path
          stroke={outline}
          strokeWidth="0.5"
          strokeMiterlimit="10"
          fill={fill}
          d="M7.9,27.9l-.7-.2c1.4-5.9,3.6-11.4,3.6-11.4l.7.3c0,0-2.2,5.5-3.6,11.3Z"
        />
        <path
          stroke={outline}
          strokeWidth="0.5"
          strokeMiterlimit="10"
          fill={fill}
          d="M6.1,25.1h-.5c.8-3,3.9-11.6,4-11.7l.5.2c0,0-3.1,8.7-4,11.5Z"
        />
        <path
          stroke={outline}
          strokeWidth="0.5"
          strokeMiterlimit="10"
          fill={fill}
          d="M4.9,23h-.5c.4-7.8,2.4-13.8,2.4-13.9l.5.2c0,0-2,6-2.3,13.7Z"
        />
        <path
          stroke={outline}
          strokeWidth="0.5"
          strokeMiterlimit="10"
          fill={fill}
          d="M30.8,41.7h-.5c0,0,.3-2.8,0-10.9h.5c.2,8.2,0,10.8,0,10.9Z"
        />
        <path
          stroke={outline}
          strokeWidth="0.5"
          strokeMiterlimit="10"
          fill={fill}
          d="M29.6,21.3c-.8-4.7-1.8-6.9-1.8-6.9l.4-.2c0,0,1.1,2.3,1.9,7h-.5Z"
        />
        <path
          stroke={outline}
          strokeWidth="0.5"
          strokeMiterlimit="10"
          fill={fill}
          d="M34.1,40.3h-.5c1.6-15-2.6-24.3-2.7-24.4l.5-.2c0,0,4.3,9.5,2.7,24.6Z"
        />
        <path
          stroke={outline}
          strokeWidth="0.5"
          strokeMiterlimit="10"
          fill={fill}
          d="M27.4,42.3h-.7c.5-4.1.6-8.7.5-13.7h.8c.1,5,0,9.6-.5,13.7Z"
        />
        <path
          stroke={outline}
          strokeWidth="0.5"
          strokeMiterlimit="10"
          fill={fill}
          d="M26.9,21.6c-.3-4.5-.8-7.5-.8-7.5h.7c0,0,.4,3,.8,7.5h-.7Z"
        />
        <path
          stroke={outline}
          strokeWidth="0.5"
          strokeMiterlimit="10"
          fill={fill}
          d="M39.1,35.1c-.1-9.3-3-16.8-3-16.9l.5-.2c0,0,2.9,7.6,3.1,17.1h-.5Z"
        />
        <path
          stroke={outline}
          strokeWidth="0.5"
          strokeMiterlimit="10"
          fill={fill}
          d="M42.4,27.9c-1.4-5.9-3.6-11.3-3.6-11.3l.7-.3c0,0,2.2,5.5,3.6,11.4l-.7.2Z"
        />
        <path
          stroke={outline}
          strokeWidth="0.5"
          strokeMiterlimit="10"
          fill={fill}
          d="M44.1,25.1c-.8-2.9-3.9-11.5-4-11.5l.5-.2c0,0,3.2,8.7,4,11.6h-.5Z"
        />
        <path
          stroke={outline}
          strokeWidth="0.5"
          strokeMiterlimit="10"
          fill={fill}
          d="M45.3,23c-.4-7.7-2.3-13.7-2.3-13.7l.5-.2c0,0,2,6.1,2.4,13.9h-.5Z"
        />
      </g>
      <path
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        fill={fill}
        d="M19.2,32.1l-2.8-12.7.9.5s2.8,1.3,7.8,1.3,7.8-1.3,7.8-1.3l.9-.4-2.3,12.7-6.4-4.7-5.9,4.7ZM25.1,26.1l5.7,4.2,1.7-9.3c-1.2.4-3.7,1.1-7.3,1.1s-6.1-.7-7.3-1.1l2,9.2,5.3-4.2Z"
      />
      <path
        stroke={outline}
        fill={outline}
        d="M25.1,43.4c-5.1,0-9.1-1.1-12-3.4C8.4,36.3,2.6,23.2,1,3.1L.8.4l1.9,1.9c.7.7,7.2,7.2,8.3,10.2.5,1.2,1.1,3.1,1.7,4.8.1-.2.3-.4.4-.6.8-.7,7.7-3.2,11.8-4.6h.3c0-.1.3,0,.3,0,4,1.4,10.7,3.9,11.5,4.6.2.2.4.4.5.7.6-1.8,1.2-3.7,1.7-4.9.9-2.5,5.5-7.4,8.2-10h0c0,0,1.7-1.7,1.7-1.7v2.3s0,0,0,.1c-1.6,20.1-7.4,33.2-12.1,36.9-2.9,2.3-6.9,3.4-12,3.4ZM3.3,5.8c2,19.1,7.6,30,11.1,32.7,2.5,2,6.1,3,10.8,3s8.2-1,10.8-3c3.5-2.7,9.1-13.6,11.1-32.7-3.2,3.4-5.4,6.1-5.9,7.4h0c-1.1,2.8-3.1,9.3-3.1,9.4l-2.4,7.7.4-8c0-1.8,0-3.7-.3-4.1-.6-.4-5.7-2.4-10.5-4.1-4.9,1.7-10.2,3.7-10.8,4.1-.2.3-.3,2.2-.2,4l.7,8.9-2.7-8.6c0,0-2.1-6.6-3.1-9.4-.6-1.6-3.6-5-5.9-7.4Z"
      />
    </g>
  )
}
